import React, { useState } from "react";
import { useSelector } from "react-redux";
import style from "./measurementSidebar.module.scss";
import { Button } from "../../../primary";
import { signedLockedAccess } from "../../../../utils";
import { MeasurementLoader } from "./measurementLoader";
import { SUCCESS_STATUS } from "../../../../constants";
import { ZoomPhoto } from "../Photos";

export const MeasurementSidebar = ({ hideIt, showMeasurementModal }) => {
  const [woundImageLoading, setWoundImageLoading] = useState(true);

  const assessmentDetail = useSelector((state) => state.patient.detailAssessment);
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const successMessage = useSelector((state) => state.patient.newWoundMeasurementStatus);

  return (
    <div className="col-4">
      {successMessage === SUCCESS_STATUS ? (
        <MeasurementLoader />
      ) : (
        <div className={style.retrace_posr}>
          <div className={`${style.patient_wound}`}>
            <ZoomPhoto
              image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL}
              loading={woundImageLoading}
              setLoading={setWoundImageLoading}
              showBottomBtn={false}
              classes={{
                outerClass: undefined,
                innerClass: "position-relative w-100",
                shimmerClass: style.image_skeleton,
              }}
              showTopBtn={assessmentDetail?.isWoundWithoutPhoto === 0}
            />
          </div>
        </div>
      )}
      {!assessmentDetail?.hasSkipMarker &&
        successMessage !== SUCCESS_STATUS &&
        signedLockedAccess(assessmentDetail?.assessmentStage) &&
        hideIt &&
        measurementData?.status === "success" && (
          <div className={`p-2 ${style.retrace_blk}`}>
            Tap{" "}
            <Button
              type="submit"
              value="Retrace"
              id="autoMeasurement"
              onClick={() => {
                showMeasurementModal("Retrace Wound Edges");
              }}
            />{" "}
            to redraw wound edges.
          </div>
        )}
    </div>
  );
};
